import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07ebccef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-container" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "fade-in",
    id: "digit1"
  }, "4"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "fade-in",
    id: "digit2"
  }, "0"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "fade-in",
    id: "digit3"
  }, "4")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fadeIn" }, "HALAMAN TIDAK DITEMUKAN", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToHome && _ctx.goToHome(...args))),
        type: "button",
        name: "button"
      }, "Kembali Ke Beranda")
    ])
  ]))
}